// userDataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api";

export const fetchUsers = createAsyncThunk("users/fetchUsers", async (searchText) => {
  const response = await api.post("/user",{ search: searchText });
  return response.data.data;
});

export const addUser = createAsyncThunk(
  "users/addUser",
  async (userData, { dispatch, rejectWithValue }) => {
    try {
      if (userData.id) {
        await api.post("/add-user", userData);
      } else {
        await api.post("/add-user", userData);
      }
      dispatch(fetchUsers());
      dispatch(closeModal());
    } catch (error) {
      return rejectWithValue("Failed to save user");
    }
  }
);

// Slice
const userDataSlice = createSlice({
  name: "userData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    error: null,
  },
  reducers: {
    openModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.data = action.payload.map((user) => ({
          id: user.id,
          name: user.name,
          email: user.email,
          phone: user.phone || "",
          created_date: user.created_at || "Not available",
          role: user.role ?? null,
        }));
        state.loading = false;
      })
      .addCase(fetchUsers.rejected, (state) => {
        state.loading = false;
      })

      .addCase(addUser.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addUser.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(addUser.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.error.message || "Failed to save user";
      });
  },
});

export const { openModal, closeModal, clearError } = userDataSlice.actions;
export default userDataSlice.reducer;
export { userDataSlice };
